import { render, staticRenderFns } from "./favourite-papers-list.html?vue&type=template&id=0d91b422&scoped=true&"
import script from "./favourite-papers-list.js?vue&type=script&lang=js&"
export * from "./favourite-papers-list.js?vue&type=script&lang=js&"
import style0 from "./favourite-papers-list.scss?vue&type=style&index=0&id=0d91b422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d91b422",
  null
  
)

export default component.exports